import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledStatsInfoCardContainer = styled.section`
  position: relative;
  padding: 1.8rem 3rem;
  border-radius: ${({ theme }) => theme.radius.small};
  background: linear-gradient(179deg, #223654 72.84%, #182337 145.61%, #151c2b 188.82%);
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;

export const StyledStatContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3.8rem;
`;
export const StyledStatHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const StyledStatHeadingText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.grey[100]};
`;

export const StyledStatText = styled.span`
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
`;

export const StyledStatIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey[100]};
`;

export const StyledChartUserIcon = styled(FontAwesomeIcon)`
  font-size: 7.5rem;
  color: rgba(113, 156, 249, 0.5);
  position: absolute;
  right: 3rem;
  bottom: 0;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;
